import type {
  RelatedPublicTrip,
  PublicTripLeg,
  PublicPriceGroup,
  RelatedPublicTripV4,
  PublicPriceGroupV4
} from "@busbud/core-types/dist/lib/poll-service/api";

export function getLegSourceNamesFromTripPrices(
  leg: PublicTripLeg | undefined,
  trip: RelatedPublicTrip | RelatedPublicTripV4 | undefined
): string[] {
  if (!leg || !trip || !trip.prices) {
    return [];
  }
  const source_names = trip.prices.reduce(
    (
      source_names: Set<string>,
      price_group: PublicPriceGroup | PublicPriceGroupV4
    ) => {
      const price_group_contains_leg_segment = price_group.segment_ids.some(
        segment_id => leg.segment_ids.includes(segment_id)
      );

      if (price_group_contains_leg_segment) {
        source_names.add(price_group.source_name);
      }

      return source_names;
    },
    new Set<string>()
  );

  return Array.from(source_names);
}

export function getUniqueSourceNamesFromSegments(
  segments: { source_name: string }[]
) {
  return Array.from(new Set(segments.map(segment => segment.source_name)));
}
